import moment from 'moment';

import { formatDiffSince } from '../utils/dates';
import { UserTypeEnum } from '../constants';

import { ContactModel, OrganizationItemModel, DistributionListItemModel, NotificationSettingsModel } from '.';
export default class UserModel {
  id: string;
  userType: UserTypeEnum;
  firstName: string;
  lastName: string;
  displayName: string;
  fullName?: string;
  prefix: string;
  title: string;
  email: string;
  active: boolean;
  community: string;
  contact: ContactModel;
  organizationIds: OrganizationItemModel[];
  distributionLists: DistributionListItemModel[];
  notificationSettings: NotificationSettingsModel;
  organizationNames: string[];
  boardId: string;
  lastLogin?: string;
  updatedAt?: string;

  //newsletter fields for validation
  username?: string;
  options?: any;
  agree?: boolean;

  getFullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  constructor(data?: any) {
    this.id = data?.id || undefined;
    this.userType = data?.userType || UserTypeEnum.User;
    this.firstName = data?.firstName || undefined;
    this.lastName = data?.lastName || undefined;
    this.displayName = data?.displayName || undefined;
    this.email = data?.email || undefined;
    this.active = data?.active ?? undefined;
    this.prefix = data?.prefix || undefined;
    this.title = data?.title || undefined;
    this.community = data?.community || undefined;
    this.contact = new ContactModel(data?.contact || {});
    this.organizationIds = Array.isArray(data?.organizations)
      ? data.organizations.map(el => new OrganizationItemModel(el))
      : [];
    this.distributionLists = Array.isArray(data?.distributionLists)
      ? data.distributionLists.map(el => new DistributionListItemModel(el))
      : [];
    this.notificationSettings = new NotificationSettingsModel(data?.notificationSettings || {});
    this.organizationNames = Array.isArray(data?.organizations) ? data.organizations.map(el => el.name) : [];
    this.boardId = data?.board?.id || undefined;
    this.lastLogin = data?.lastLogin ? formatDiffSince(moment.unix(data.lastLogin)) : undefined;
    this.updatedAt = data?.updatedAt ? moment.unix(data.updatedAt).format('ll') : undefined;
    this.fullName = data?.firstName && data?.lastName ? this.getFullName() : undefined;
    this.username = this.fullName ? this.fullName : '';
    this.options = { lwb: false, rboard: false };
    this.agree = false;
  }
}
